import { LOCALES } from '../constants';
import { TranslationItem } from '../types/translations.types';

export const getTranslation = (
  translations: TranslationItem[],
  locale: LOCALES,
  keyId: string,
): string => {
  const translation = translations.find(
    t => t.locale === locale && t.keyId === keyId,
  );
  return translation ? translation.text : '';
};

const supportedLocales = ['fi_FI', 'en_EN'];

export function ensureTranslationItems(
  translations: TranslationItem[] | undefined,
  keyId: string,
): TranslationItem[] {
  return supportedLocales.map(locale => {
    const existing = translations?.find(item => item.locale === locale);

    return (
      existing ?? {
        locale,
        keyId,
        text: '',
      }
    );
  });
}
